import { constantsData, formFieldNamesData, optionsData } from "@/data";
import { AsyncDataKeyEnum, FieldTypeEnum, InputTypeEnum } from "@/enums";

const {
    account,
    frequency,
    name,
} = constantsData.forms.dataSources.setup.online;

const {
    account: accountFieldName,
    frequency: frequencyFieldName,
    name: nameFieldName,
} = formFieldNamesData;

export const setupOnlineDataSourceFormData = [
    {
        description: name.description,
        label: name.label,
        name: nameFieldName,
        type: InputTypeEnum.TEXT,
    },
    {
        dataKey: AsyncDataKeyEnum.ACCOUNTS,
        description: account.description,
        isAsync: true,
        label: account.label,
        name: accountFieldName,
        type: FieldTypeEnum.SELECT,
    },
    {
        description: frequency.description,
        hasOptionFormat: true,
        isDisabled: true,
        label: frequency.label,
        name: frequencyFieldName,
        options: optionsData.dataSource.syncFrequencies,
        type: FieldTypeEnum.SELECT,
    },
];
